<script setup>
import SignaturePad from 'signature_pad'
import {onMounted, ref} from 'vue'

const pad = ref()
const canvas = ref()

const clear = () => {
    pad.value.clear()
}

const isEmpty = () => {
    return pad.value.isEmpty()
}

const getValue = () => {
    return pad.value.toDataURL()
}

onMounted(() => {
    pad.value = new SignaturePad(canvas.value)

    setTimeout(() => {
        const canv = canvas.value
        canv.width = canv.offsetWidth
        canv.height = canv.offsetHeight
    }, 250)

    pad.value.clear()
})

defineExpose({
    clear,
    isEmpty,
    getValue
})
</script>

<template>
    <div class="signature-pad">
        <canvas ref="canvas" />
    </div>
</template>

<style lang="scss" scoped>
.signature-pad {
    width: 100%;
    height: 100%;
    position: relative;

    canvas {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}
</style>
